import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BRAND } from "@/lib/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const launch = (data) => {
  if (window.Tebex?.checkout && data.basket_ident) {
    window.Tebex.checkout.init({
      ident: data.basket_ident,
      theme: "dark",
      closeOnPaymentComplete: false,
    });
    window.Tebex.checkout.launch();
    return true;
  }
  if (data.checkout_url) {
    window.location.href = data.checkout_url;
    return true;
  }
  return false;
};

export const useCheckout = () => {
  const [pending, setPending] = useState(null);

  const buy = async (slug = "fight-studio") => {
    if (pending) return;
    setPending(slug);
    try {
      const { data } = await axios.post(`${API}/checkout`, { slug, quantity: 1 });

      if (!data.configured) {
        toast.info("Not on sale yet", {
          description:
            data.message ||
            "This one isn't published on Tebex yet. Join the Discord for the release announcement.",
          action: { label: "Discord", onClick: () => window.open(BRAND.discord, "_blank", "noopener") },
        });
        return;
      }

      if (data.requires_auth && data.auth_url) {
        toast.info("Link your FiveM account", {
          description: "Tebex needs your Cfx.re account to deliver your files. Redirecting…",
        });
        window.location.href = data.auth_url;
        return;
      }

      if (launch(data)) return;

      toast.error("Could not open checkout", { description: data.message || "Please try again." });
    } catch (e) {
      toast.error("Checkout failed", { description: "Please try again in a moment." });
    } finally {
      setPending(null);
    }
  };

  return { buy, pending, loading: Boolean(pending) };
};
